import { closeAccountApi } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

export const useDeleteAccountQuery = () => {
	return useMutation({
		mutationFn: async () => {
			const api = await closeAccountApi;

			await api.postCloseAccountRequestMe();
		}
	});
};
